import * as Yup from 'yup';

export const CompletionNoteSchema = Yup.object().shape({
  text: Yup.string().required(),
});
